module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('strong', [_c('em', [_vm._v("Editor’s Preface")])])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Commentaries have specific aims, and this series is no exception. Designed for serious pastors and teachers of the Bible, the Pillar commentaries seek above all to make clear the text of Scripture as we have it. The scholars writing these volumes interact with the most important informed contemporary debate, but avoid getting mired in undue technical detail. Their ideal is a blend of rigorous exegesis and exposition, with an eye alert both to biblical theology and the contemporary relevance of the Bible, without confusing the commentary and the sermon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The rationale for this approach is that the vision of “objective scholarship” (a vain chimera) may actually be profane. God stands over against us; we do not stand in judgment of him. When God speaks to us through his Word, those who profess to know him must respond in an appropriate way, and that is certainly different from a stance in which the scholar projects an image of autonomous distance. Yet this is no surreptitious appeal for uncontrolled subjectivity. The writers of this series aim for an evenhanded openness to the text that is the best kind of “objectivity” of all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If the text is God’s Word, it is appropriate that we respond with reverence, a certain fear, a holy joy, a questing obedience. These values should be reflected in the way Christians write. With these values in place, the Pillar commentaries will be warmly welcomed not only by pastors, teachers, and students, but by general readers as well.")]), _vm._v(" "), _c('p', {
    staticClass: "design"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("For many years Doug Moo and I served on the same faculty. His move from Trinity to Wheaton, however much a gain for the latter, was a ")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("personal loss. Mercifully, we have continued to collaborate on various projects, and he is surely among the two or three scholars with whom I am most happy to work in close association. Readers of this series will already be familiar with his Pillar commentary on James — and that after writing, for another series, what is still the best English-language commentary on Romans.")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Colossians and Philemon speak powerfully to many issues in the twenty-first century. What has consumed a great deal of energy in contemporary scholarship on these epistles, however, has often been the construction of plausible “backgrounds” that then determine (I almost said “domesticate”) the interpretation of the documents. These backgrounds are now so plentiful and so diverse that the corresponding interpretations are equally plentiful. One of the many strengths that Dr. Moo brings to this commentary is an ability to evaluate the relative merits of diverse appeals, and even to point out what one cannot know when the evidence is not all that secure — and then to work carefully through the text in an exegetical and theological manner to make clear what the text itself does say. All of this is couched in lucid prose with transparent hints as to the bearing of the biblical texts on today’s church. Anyone who reads through this commentary will emerge with a stronger grasp of what is disclosed in these two letters. I shall not be surprised if it becomes a “standard” among pastors for many years to come. And once again I am deeply indebted to a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "p-right"
  }, [_vm._v("D. A. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARSON")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5c47414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Editorspreface.vue
// module id = 69
// module chunks = 0